import { createFloatGesture } from './floatFactory.js';
export default createFloatGesture('left');
